<template>

  <div class="layout-wrapper">

    <!-- HERO -->
    <section
      ref="hero"
      class="hero-section d-flex align-items-center"
      :style="heroStyle"
    >

     <img
              v-if="header?.logo"
              src="https://gestionaleimmagini.s3.eu-central-1.amazonaws.com/fredericmalle26/bg_3.png"
              width="100%"
             class="mobile"
            >

      <div class="container position-relative text-center desktop">

        <!-- NAVBAR -->

          <div class="container-fluid">

            <img
              v-if="header?.logo"
              :src="header.logo"
              width="100%"
              class="me-3"
            >

          </div>

        <!-- HERO TEXT -->

      </div>

    </section>

    <!-- MAIN -->

    <section class="main-content  bg-light" >

      <div class="container content-wrapper" style="margin-top:20px;margin-bottom:100px">

        <DynamicForm
        :schema="schema"
        :layout="layout"
        :header="header"
        :theme="theme"
        @submitted="$emit('submitted', $event)"
      />

      </div>

    </section>

  </div>

</template>

<script>

import DynamicForm from '@/components/DynamicForm'

export default {

  name: 'HeroLayout',
  components: { DynamicForm },
  props: [
    'theme',
    'header',
    'footer',
    'schema',
    'layout'
  ],

  data () {
    return {
      heroGlowColor: 'rgba(0,0,0,0.5)',
      heroTextColor: '#ffffff',
      heroTextShadow: '0 2px 10px rgba(0,0,0,0.9)'
    }
  },

  computed: {

    heroStyle () {
      return {

        background: this.theme?.backgroundImage ? `url(${this.theme.backgroundImage}) center/cover no-repeat` : `linear-gradient(135deg, ${this.theme?.primaryColor || '#ce4135'}, ${this.theme?.secondaryColor || '#ce4135'})`, position: 'relative'
      }
    },

    textStyle () {
      return {
        color: this.heroTextColor,
        textShadow: this.heroTextShadow
      }
    }

  },

  watch: {

    'theme.backgroundImage': {
      immediate: true,
      handler () {
        this.extractDominantColor()
      }
    }

  },

  methods: {

    extractDominantColor () {
      if (!this.theme?.backgroundImage) return

      const img = new Image()
      img.crossOrigin = 'Anonymous'
      // img.src = this.theme.backgroundImage
      const apiBase = process.env.VUE_APP_API
      const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      img.src = apiBase + '/proxy-image.php?url=' + encodeURIComponent(this.theme.backgroundImage) + '&controllo=' + session

      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = img.width
        canvas.height = img.height
        ctx.drawImage(img, 0, 0)
        const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data
        let r = 0; let g = 0; let b = 0; let count = 0
        for (let i = 0; i < data.length; i += 40) {
          r += data[i]
          g += data[i + 1]
          b += data[i + 2]
          count++
        }
        r = Math.floor(r / count)
        g = Math.floor(g / count)
        b = Math.floor(b / count)
        this.heroGlowColor = `rgba(${r},${g},${b},0.6)`
        this.heroTextColor = `rgba(${r},${g},${b},1)`
      }
    }

  }

}

</script>

<style scoped>

.layout-wrapper{

  display:flex;

  flex-direction:column;

  min-height:100vh;

}

.hero-section{

  position:relative;

}

.overlay{

  position:absolute;

  inset:0;

  background:rgba(0,0,0,0.35);

}

.main-content{

  flex:1;

}

.footer{

  margin-top:auto;

}

.mobile {
  display: none;
}

.desktop{
  display: block;
}

@media (max-width: 576px) {

  .mobile {
  display:  block;
}

.desktop{
  display: none;
}

  /* 1) elimina padding laterale bootstrap nella hero */
  .hero-section .container,
  .hero-section .container-fluid {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /* 2) elimina margini dell'immagine (me-3 ecc.) */
  .hero-section img {
    display: block;
    margin: 0 !important;
  }

  /* 3) forza il full-bleed anche se rimane dentro un container */
  .hero-section .container-fluid {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }

  /* immagine a tutta larghezza della viewport */
  .hero-section .container-fluid img {
    width: 100% !important;
    height: auto;
  }

  .content-wrapper{
    padding-left: 30px;
    padding-right: 30px;
    background-color: #fff;

  }

  /* evita eventuale scroll orizzontale dovuto al 100vw */
  .layout-wrapper {
    overflow-x: hidden;

  }
}

</style>
